// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:root {
  --loader-size: 32px;
  --loader-size-double: calc(var(--loader-size) * 2);
  --animation-time: 6s;
}

.augmented-loader {
  color: white;
  width: var(--loader-size-double);
  height: var(--loader-size-double);
  position: relative;
  perspective: unset;
  text-align: center;
  margin: auto;
  top: 46%;
  transform: translateY(-50%);
}

.augmented-loader-bg {
  position: absolute;
  background-color: rgba(0, 0, 0, 0.9764705882);
  top: 0;
  bottom: 0;
  left: 0;
  right: 0;
  height: 100%;
  z-index: 1;
}

.loading-info {
  position: relative;
  display: block;
  padding-top: 16px;
  min-width: 300px;
  transform: translateX(-50%);
  left: 50%;
}

.motes-logo svg {
  color: white;
  width: calc(var(--loader-size-double) + 4px);
  height: calc(var(--loader-size-double) + 4px);
  position: relative;
  top: 0;
  margin-top: -2px;
  margin-left: -2px;
  animation: logo-fadeout var(--animation-time);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
}

.logo-inside svg {
  color: white;
  width: calc(var(--loader-size-double));
  height: calc(var(--loader-size-double));
  position: absolute;
  top: 50%;
  left: 50%;
  animation: zoom-logo-inside var(--animation-time);
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.cube-scene {
  width: var(--loader-size-double);
  height: var(--loader-size-double);
  animation: perspective-cube var(--animation-time);
  animation-iteration-count: infinite;
  animation-fill-mode: forwards;
  position: absolute;
}

.cube {
  position: relative;
  width: inherit;
  height: inherit;
  transform-style: preserve-3d;
  transform: rotateY(180deg);
  animation: rotate-cube var(--animation-time) linear 1;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
}

.cube-fadein {
  position: relative;
  width: inherit;
  height: inherit;
  animation: cube-fadein var(--animation-time) ease-in-out;
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  position: absolute;
}

.cube-face {
  width: inherit;
  height: inherit;
  position: absolute;
  background: var(--motes-red);
  animation: logo-to-square var(--animation-time);
  animation-iteration-count: infinite;
  animation-fill-mode: both;
  opacity: 0.5;
}

.cube-face-front {
  background: var(--motes-gold);
  transform: translate3d(0, 0, var(--loader-size));
}

.cube-face-back {
  background: var(--motes-gold);
  transform: rotateY(180deg) translate3d(0, 0, var(--loader-size));
}

.cube-face-left {
  background: var(--motes-green);
  transform: rotateY(-90deg) translate3d(0, 0, var(--loader-size));
}

.cube-face-right {
  background: var(--motes-green);
  transform: rotateY(90deg) translate3d(0, 0, var(--loader-size));
}

.cube-face-top {
  background: var(--motes-blue);
  transform: rotateX(90deg) translate3d(0, 0, var(--loader-size));
}

.cube-face-bottom {
  background: var(--motes-blue);
  transform: rotateX(-90deg) translate3d(0, 0, var(--loader-size));
}

@keyframes cube-fadein {
  0% {
    opacity: 0;
  }
  5% {
    opacity: 0;
  }
  12% {
    opacity: 1;
  }
  90% {
    opacity: 1;
  }
  94% {
    opacity: 0;
  }
  100% {
    opacity: 0;
  }
}
@keyframes logo-to-square {
  0% {
    border-radius: 50%;
    opacity: 1;
    background-color: rgb(255, 255, 255);
  }
  20% {
    border-radius: 0%;
    opacity: 1;
  }
  80% {
    border-radius: 0%;
    opacity: 0.4;
  }
  85% {
    border-radius: 50%;
    opacity: 0.4;
  }
  100% {
    border-radius: 50%;
    opacity: 0;
  }
}
@keyframes logo-fadeout {
  0% {
    opacity: 1;
    transform: rotate(0deg);
  }
  8% {
    opacity: 1;
    transform: rotate(0deg);
  }
  10% {
    opacity: 1;
    transform: rotate(0deg);
  }
  12% {
    opacity: 0;
    transform: rotate(0deg);
  }
  88% {
    opacity: 0;
    transform: rotate(360deg);
  }
  100% {
    opacity: 1;
    transform: rotate(360deg);
  }
}
@keyframes perspective-cube {
  0% {
    perspective: 10000px;
  }
  40% {
    perspective: 10000px;
  }
  50% {
    perspective: 600px;
  }
  70% {
    perspective: 600px;
  }
  80% {
    perspective: 10000px;
  }
  100% {
    perspective: 10000px;
  }
}
@keyframes rotate-cube {
  0% {
    transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);
  }
  30% {
    transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);
  }
  40% {
    transform: rotateY(180deg) rotateX(0deg) rotateZ(0deg);
  }
  50% {
    transform: rotateY(360deg) rotateX(45deg) rotateZ(0deg);
  }
  60% {
    transform: rotateY(720deg) rotateX(45deg) rotateZ(45deg);
  }
  70% {
    transform: rotateY(900deg) rotateX(45deg) rotateZ(45deg);
  }
  80% {
    transform: rotateY(1080deg) rotateX(0deg) rotateZ(0deg);
  }
  100% {
    transform: rotateY(1080deg) rotateX(0deg) rotateZ(0deg);
  }
}
@keyframes zoom-logo-inside {
  0% {
    transform: translateY(-50%) translateX(-50%) scale(0.5);
    opacity: 0;
  }
  40% {
    transform: translateY(-50%) translateX(-50%) scale(0.5);
    opacity: 0;
  }
  70% {
    transform: translateY(-50%) translateX(-50%) scale(0.5);
    opacity: 1;
  }
  76% {
    transform: translateY(-50%) translateX(-50%) scale(0.5);
    opacity: 1;
  }
  92% {
    transform: translateY(-50%) translateX(-50%) scale(1.1);
    opacity: 1;
  }
  98% {
    transform: translateY(-50%) translateX(-50%) scale(1.1);
    opacity: 1;
  }
  100% {
    transform: translateY(-50%) translateX(-50%) scale(2.1);
    opacity: 0;
  }
}`, "",{"version":3,"sources":["webpack://./motes-sdk/src/components/loading/loading-3d.scss"],"names":[],"mappings":"AAAA;EACI,mBAAA;EACA,kDAAA;EACA,oBAAA;AACJ;;AAEA;EACI,YAAA;EACA,gCAAA;EACA,iCAAA;EACA,kBAAA;EACA,kBAAA;EACA,kBAAA;EACA,YAAA;EACA,QAAA;EACA,2BAAA;AACJ;;AAEA;EACI,kBAAA;EACA,6CAAA;EACA,MAAA;EACA,SAAA;EACA,OAAA;EACA,QAAA;EACA,YAAA;EACA,UAAA;AACJ;;AAEA;EACI,kBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,2BAAA;EACA,SAAA;AACJ;;AAEA;EACI,YAAA;EACA,4CAAA;EACA,6CAAA;EACA,kBAAA;EACA,MAAA;EACA,gBAAA;EACA,iBAAA;EAEA,6CAAA;EACA,mCAAA;EACA,6BAAA;AAAJ;;AAGA;EACI,YAAA;EACA,sCAAA;EACA,uCAAA;EACA,kBAAA;EACA,QAAA;EACA,SAAA;EACA,iDAAA;EACA,mCAAA;EACA,yBAAA;AAAJ;;AAGA;EACI,gCAAA;EACA,iCAAA;EACA,iDAAA;EACA,mCAAA;EACA,6BAAA;EACA,kBAAA;AAAJ;;AAGA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EAEA,4BAAA;EACA,0BAAA;EACA,qDAAA;EACA,mCAAA;EACA,yBAAA;AADJ;;AAIA;EACI,kBAAA;EACA,cAAA;EACA,eAAA;EACA,wDAAA;EACA,mCAAA;EACA,yBAAA;EACA,kBAAA;AADJ;;AAIA;EACI,cAAA;EACA,eAAA;EACA,kBAAA;EACA,4BAAA;EACA,+CAAA;EACA,mCAAA;EACA,yBAAA;EACA,YAAA;AADJ;;AAIA;EACI,6BAAA;EACA,gDAAA;AADJ;;AAIA;EACI,6BAAA;EACA,gEAAA;AADJ;;AAIA;EACI,8BAAA;EACA,gEAAA;AADJ;;AAIA;EACI,8BAAA;EACA,+DAAA;AADJ;;AAIA;EACI,6BAAA;EACA,+DAAA;AADJ;;AAIA;EACI,6BAAA;EACA,gEAAA;AADJ;;AAIA;EACI;IACI,UAAA;EADN;EAIE;IACI,UAAA;EAFN;EAKE;IACI,UAAA;EAHN;EAME;IACI,UAAA;EAJN;EAOE;IACI,UAAA;EALN;EAQE;IACI,UAAA;EANN;AACF;AASA;EACI;IACI,kBAAA;IACA,UAAA;IACA,oCAAA;EAPN;EASE;IACI,iBAAA;IACA,UAAA;EAPN;EASE;IACI,iBAAA;IACA,YAAA;EAPN;EASE;IACI,kBAAA;IACA,YAAA;EAPN;EASE;IACI,kBAAA;IACA,UAAA;EAPN;AACF;AAUA;EACI;IACI,UAAA;IACA,uBAAA;EARN;EAWE;IACI,UAAA;IACA,uBAAA;EATN;EAYE;IACI,UAAA;IACA,uBAAA;EAVN;EAaE;IACI,UAAA;IACA,uBAAA;EAXN;EAcE;IACI,UAAA;IACA,yBAAA;EAZN;EAeE;IACI,UAAA;IACA,yBAAA;EAbN;AACF;AAgBA;EACI;IACI,oBAAA;EAdN;EAgBE;IACI,oBAAA;EAdN;EAgBE;IACI,kBAAA;EAdN;EAiBE;IACI,kBAAA;EAfN;EAiBE;IACI,oBAAA;EAfN;EAiBE;IACI,oBAAA;EAfN;AACF;AAkBA;EACI;IACI,oDAAA;EAhBN;EAkBE;IACI,oDAAA;EAhBN;EAmBE;IACI,sDAAA;EAjBN;EAoBE;IACI,uDAAA;EAlBN;EAqBE;IACI,wDAAA;EAnBN;EAsBE;IACI,wDAAA;EApBN;EAsBE;IACI,uDAAA;EApBN;EAsBE;IACI,uDAAA;EApBN;AACF;AAuBA;EACI;IACI,uDAAA;IACA,UAAA;EArBN;EAwBE;IACI,uDAAA;IACA,UAAA;EAtBN;EAyBE;IACI,uDAAA;IACA,UAAA;EAvBN;EA0BE;IACI,uDAAA;IACA,UAAA;EAxBN;EA2BE;IACI,uDAAA;IACA,UAAA;EAzBN;EA4BE;IACI,uDAAA;IACA,UAAA;EA1BN;EA6BE;IACI,uDAAA;IACA,UAAA;EA3BN;AACF","sourcesContent":[":root {\n    --loader-size: 32px;\n    --loader-size-double: calc(var(--loader-size) * 2);\n    --animation-time: 6s;\n}\n\n.augmented-loader {\n    color: white;\n    width: var(--loader-size-double);\n    height: var(--loader-size-double);\n    position: relative;\n    perspective: unset;\n    text-align: center;\n    margin: auto;\n    top: 46%;\n    transform: translateY(-50%);\n}\n\n.augmented-loader-bg {\n    position: absolute;\n    background-color: #000000f9;\n    top: 0;\n    bottom: 0;\n    left: 0;\n    right: 0;\n    height: 100%;\n    z-index: 1;\n}\n\n.loading-info {\n    position: relative;\n    display: block;\n    padding-top: 16px;\n    min-width: 300px;\n    transform: translateX(-50%);\n    left: 50%;\n}\n\n.motes-logo svg {\n    color: white;\n    width: calc(var(--loader-size-double) + 4px);\n    height: calc(var(--loader-size-double) + 4px);\n    position: relative;\n    top: 0;\n    margin-top: -2px;\n    margin-left: -2px;\n\n    animation: logo-fadeout var(--animation-time);\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards;\n}\n\n.logo-inside svg {\n    color: white;\n    width: calc(var(--loader-size-double));\n    height: calc(var(--loader-size-double));\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    animation: zoom-logo-inside var(--animation-time);\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n}\n\n.cube-scene {\n    width: var(--loader-size-double);\n    height: var(--loader-size-double);\n    animation: perspective-cube var(--animation-time);\n    animation-iteration-count: infinite;\n    animation-fill-mode: forwards;\n    position: absolute;\n}\n\n.cube {\n    position: relative;\n    width: inherit;\n    height: inherit;\n\n    transform-style: preserve-3d;\n    transform: rotateY(180deg);\n    animation: rotate-cube var(--animation-time) linear 1;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n}\n\n.cube-fadein {\n    position: relative;\n    width: inherit;\n    height: inherit;\n    animation: cube-fadein var(--animation-time) ease-in-out;\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    position: absolute;\n}\n\n.cube-face {\n    width: inherit;\n    height: inherit;\n    position: absolute;\n    background: var(--motes-red);\n    animation: logo-to-square var(--animation-time);\n    animation-iteration-count: infinite;\n    animation-fill-mode: both;\n    opacity: 0.5;\n}\n\n.cube-face-front {\n    background: var(--motes-gold);;\n    transform: translate3d(0, 0, var(--loader-size));\n}\n\n.cube-face-back {\n    background: var(--motes-gold);\n    transform: rotateY(180deg) translate3d(0, 0, var(--loader-size));\n}\n\n.cube-face-left {\n    background: var(--motes-green);\n    transform: rotateY(-90deg) translate3d(0, 0, var(--loader-size));\n}\n\n.cube-face-right {\n    background: var(--motes-green);\n    transform: rotateY(90deg) translate3d(0, 0, var(--loader-size));\n}\n\n.cube-face-top {\n    background:  var(--motes-blue);\n    transform: rotateX(90deg) translate3d(0, 0, var(--loader-size));\n}\n\n.cube-face-bottom {\n    background: var(--motes-blue);\n    transform: rotateX(-90deg) translate3d(0, 0, var(--loader-size));\n}\n\n@keyframes cube-fadein {\n    0% {\n        opacity: 0;\n    }\n\n    5% {\n        opacity: 0;\n    }\n\n    12% {\n        opacity: 1;\n    }\n\n    90% {\n        opacity: 1;\n    }\n    \n    94% {\n        opacity: 0;\n    }\n    \n    100% {\n        opacity: 0;\n    }\n}\n\n@keyframes logo-to-square {\n    0% {\n        border-radius: 50%;\n        opacity: 1;\n        background-color: rgb(255, 255, 255);\n    }\n    20% {\n        border-radius: 0%;\n        opacity: 1;\n    }\n    80% {\n        border-radius: 0%;\n        opacity: 0.4;\n    }\n    85% {\n        border-radius: 50%;\n        opacity: 0.4;\n    }\n    100% {\n        border-radius: 50%;\n        opacity: 0;\n    }\n}\n\n@keyframes logo-fadeout {\n    0% {\n        opacity: 1;\n        transform: rotate(0deg);\n    }\n\n    8% {\n        opacity: 1;\n        transform: rotate(0deg);\n    }\n\n    10% {\n        opacity: 1;\n        transform: rotate(0deg);\n    }\n\n    12% {\n        opacity: 0;\n        transform: rotate(0deg);\n    }\n\n    88% {\n        opacity: 0;\n        transform: rotate(360deg);\n    }\n\n    100% {\n        opacity: 1;\n        transform: rotate(360deg);\n    }\n}\n\n@keyframes perspective-cube {\n    0% {\n        perspective: 10000px;\n    }\n    40% {\n        perspective: 10000px;\n    }\n    50% {\n        perspective: 600px;\n    }\n\n    70% {\n        perspective: 600px;\n    }\n    80% {\n        perspective: 10000px;\n    }\n    100% {\n        perspective: 10000px;\n    }\n}\n\n@keyframes rotate-cube {\n    0% {\n        transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);\n    }\n    30% {\n        transform: rotateY(0deg) rotateX(0deg) rotateZ(0deg);\n    }\n\n    40% {\n        transform: rotateY(180deg) rotateX(0deg) rotateZ(0deg);\n    }\n\n    50% {\n        transform: rotateY(360deg) rotateX(45deg) rotateZ(0deg);\n    }\n\n    60% {\n        transform: rotateY(720deg) rotateX(45deg) rotateZ(45deg);\n    }\n\n    70% {\n        transform: rotateY(900deg) rotateX(45deg) rotateZ(45deg);\n    }\n    80% {\n        transform: rotateY(1080deg) rotateX(0deg) rotateZ(0deg);\n    }\n    100% {\n        transform: rotateY(1080deg) rotateX(0deg) rotateZ(0deg);\n    }\n}\n\n@keyframes zoom-logo-inside {\n    0% {\n        transform: translateY(-50%) translateX(-50%) scale(0.5);\n        opacity: 0;\n    }\n\n    40% {\n        transform: translateY(-50%) translateX(-50%) scale(0.5);\n        opacity: 0;\n    }\n\n    70% {\n        transform: translateY(-50%) translateX(-50%) scale(0.5);\n        opacity: 1;\n    }\n\n    76% {\n        transform: translateY(-50%) translateX(-50%) scale(0.5);\n        opacity: 1;\n    }\n\n    92% {\n        transform: translateY(-50%) translateX(-50%) scale(1.1);\n        opacity: 1;\n    }\n\n    98% {\n        transform: translateY(-50%) translateX(-50%) scale(1.1);\n        opacity: 1;\n    }\n\n    100% {\n        transform: translateY(-50%) translateX(-50%) scale(2.1);\n        opacity: 0;\n    }\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
